import React from "react";
import { Table, Tag, Tooltip, Typography } from "antd";
import dayjs from "dayjs";
import { IncidentSummary } from "../../../interfaces/paymentHealth.interface";
import { severityMeta, statusMeta } from "../paymentHealthDisplay";

interface IncidentHistoryTableProps {
  incidents: IncidentSummary[];
}

const IncidentHistoryTable: React.FC<IncidentHistoryTableProps> = ({
  incidents,
}) => {
  const columns = [
    {
      title: "Component",
      dataIndex: "component",
      key: "component",
    },
    {
      title: "Severity",
      dataIndex: "severity",
      key: "severity",
      render: (_: unknown, r: IncidentSummary) => {
        const m = severityMeta(r.severity);
        return <Tag color={m.color}>{m.label}</Tag>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: unknown, r: IncidentSummary) => {
        const m = statusMeta(r.status);
        return <Tag color={m.color}>{m.label}</Tag>;
      },
    },
    {
      title: "Started",
      dataIndex: "startedAt",
      key: "startedAt",
      render: (v: string) => dayjs(v).format("MMM D, HH:mm"),
    },
    {
      title: "Resolved",
      dataIndex: "resolvedAt",
      key: "resolvedAt",
      render: (v?: string) => (v ? dayjs(v).format("MMM D, HH:mm") : "-"),
    },
    {
      title: "Merchants",
      dataIndex: "affectedMerchantCount",
      key: "affectedMerchantCount",
      align: "right" as const,
    },
    {
      title: "Resolution",
      key: "resolution",
      render: (_: unknown, r: IncidentSummary) => {
        if (!r.resolutionType) return "-";
        const label =
          r.resolutionType === "false_positive"
            ? "False positive"
            : r.resolutionType === "manual"
              ? "Manual"
              : "Auto";
        const by = r.resolvedBy ? ` by ${r.resolvedBy}` : "";
        return r.resolutionNote ? (
          <Tooltip title={r.resolutionNote}>
            <Typography.Text>{`${label}${by}`}</Typography.Text>
          </Tooltip>
        ) : (
          <Typography.Text>{`${label}${by}`}</Typography.Text>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      rowKey="id"
      columns={columns}
      dataSource={incidents}
      pagination={{ pageSize: 10, hideOnSinglePage: true }}
      scroll={{ x: true }}
    />
  );
};

export default IncidentHistoryTable;
